import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ActionButton from 'components/button/ActionButton';
import Dialog from 'components/ui/dialog/Dialog';
import FileDropzoneField from 'components/input/Dropzone/FileDropzoneField';
import Loader from 'components/loading/Loader';
import PrimaryButton from 'components/button/PrimaryButton';
import { BackupIcon } from 'assets/materialIcons/materialIcons';
import { compose } from 'recompose';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';

const StyledWrapper = styled.div`
    display: block;
`;

const StyledButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const DialogLoader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
`;

class FileUploadButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            open: false,
        };
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading,
        });
    }

    onSuccess = () => {
        this.setState({
            open: false,
        }, () => {
            this.setLoading(false);
        });
    }

    onError = () => {
        this.setLoading(false);
    }

    render() {
        const {
            action,
            acceptedFormat,
            buttonTitle,
            dialogTitle,
            dropzoneDescription,
            formDataKey,
            modal,
            title,
            translate,
        } = this.props;

        const {
            loading,
            open,
        } = this.state;

        const actions = [
            <PrimaryButton
                key='close-button'
                label={ translate('actions.close') }
                onClick={ () => {
                    this.setState({
                        open: false,
                    });
                } }
            />,
        ];

        return (
            <StyledWrapper>
                <StyledButtonWrapper>
                    <ActionButton
                        icon={ <BackupIcon color={ theme.palette.doveGray } /> }
                        onClick={ () => {
                            this.setState({
                                open: true,
                            });
                        } }
                        title={ title }
                    />
                </StyledButtonWrapper>

                <Dialog
                    actions={ actions }
                    title={ dialogTitle }
                    actionsContainerStyle={ {
                        padding: '20px 20px 20px 0',
                    } }
                    bodyStyle={ {
                        padding: '0 20px',
                        margin: '20px 0',
                    } }
                    modal={ modal }
                    autoScrollBodyContent={ true }
                    autoDetectWindowHeight={ true }
                    onRequestClose={ () => {
                        this.setState({
                            open: false,
                        });
                    } }
                    open={ open }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    titleStyle={ {
                        padding: '30px 20px 10px',
                        margin: '0',
                    } }
                >
                    <FileDropzoneField
                        acceptedFormat={ acceptedFormat }
                        createAction={ action }
                        description={ dropzoneDescription }
                        formDataKey={ formDataKey }
                        dropZoneId='file-import-container'
                        buttonText={ buttonTitle }
                        onSuccess={ this.onSuccess }
                        onError={ this.onError }
                        setLoadingOn={ () => {
                            this.setLoading(true);
                        } }
                    />

                    { loading &&
                        <DialogLoader>
                            <Loader size={ 50 } />
                        </DialogLoader>
                    }
                </Dialog>
            </StyledWrapper>
        );
    }
}

FileUploadButton.defaultProps = {
    formDataKey: 'file',
};

FileUploadButton.propTypes = {
    acceptedFormat: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
    buttonTitle: PropTypes.string.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    dropzoneDescription: PropTypes.string,
    formDataKey: PropTypes.string,
    modal: PropTypes.bool,
    title: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
);

export default enhance(FileUploadButton);


// WEBPACK FOOTER //
// ./src/components/button/FileUploadButton.js